import { render, staticRenderFns } from "./BillingDetails.vue?vue&type=template&id=da478bce&scoped=true"
import script from "./BillingDetails.vue?vue&type=script&lang=js"
export * from "./BillingDetails.vue?vue&type=script&lang=js"
import style0 from "./BillingDetails.vue?vue&type=style&index=0&id=da478bce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da478bce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da478bce')) {
      api.createRecord('da478bce', component.options)
    } else {
      api.reload('da478bce', component.options)
    }
    module.hot.accept("./BillingDetails.vue?vue&type=template&id=da478bce&scoped=true", function () {
      api.rerender('da478bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/BillingDetails.vue"
export default component.exports